import { render } from "./LocationItem.vue?vue&type=template&id=2feff5d7&scoped=true"
import script from "./LocationItem.vue?vue&type=script&lang=js"
export * from "./LocationItem.vue?vue&type=script&lang=js"

import "./LocationItem.vue?vue&type=style&index=0&id=2feff5d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feff5d7"]])

export default __exports__